import { render, staticRenderFns } from "./CognitiveRZSL.vue?vue&type=template&id=e2052bba&scoped=true"
import script from "./CognitiveRZSL.vue?vue&type=script&lang=js"
export * from "./CognitiveRZSL.vue?vue&type=script&lang=js"
import style0 from "./CognitiveRZSL.vue?vue&type=style&index=0&id=e2052bba&prod&scoped=true&lang=css"
import style1 from "./CognitiveRZSL.vue?vue&type=style&index=1&id=e2052bba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2052bba",
  null
  
)

export default component.exports